import { FaBan } from "react-icons/fa";
import DropdownItemBase from "./DropdownItemBase";
import { useTranslation } from "react-i18next";

const DropdownItemExameBloqueado = ({ notif, onClick }) => {
    const { t } = useTranslation(['layout']);
    const info = notif.atendimento_info;
    if (!info) return null;

    let dataFormatada = info.data_criacao || "";
    if (dataFormatada && !dataFormatada.includes('/')) {
            try {
                dataFormatada = new Date(dataFormatada).toLocaleString("pt-BR");
            } catch (e) {}
    }

    return (
        <DropdownItemBase
            icon={<FaBan />}
            text="text-danger"
            titulo={t('layout:notificationItems.examBlocked.title')}
            descricao={
                <>
                    <div>{t('layout:notificationItems.label.patient')}: <strong>{info.beneficiario_nome}</strong></div>
                    {notif.dados?.exame_nome && isNaN(notif.dados.exame_nome) && (
                        <div>{t('layout:notificationItems.label.exam')}: <strong>{notif.dados.exame_nome}</strong></div>
                    )}
                </>
            }
            subDescricao={
                <>
                    <div>{t('layout:notificationItems.label.program')}: {info.programa_nome}</div>
                    {notif.dados?.medico_nome && (
                        <div>{t('layout:notificationItems.label.doctor')}: {notif.dados.medico_nome}</div>
                    )}
                </>
            }
            dataFormatada={dataFormatada}
            onClick={() => onClick(notif)}
        />
    );
};

export default DropdownItemExameBloqueado;
